import {dafMainServices} from '../../ella-dispo-entity-types';

export const driverAssignmentsArchiveMainServices = [
    dafMainServices.ROADSIDE_ASSISTANCE,
    dafMainServices.JUMP_START,
    dafMainServices.OPENING,
    dafMainServices.TOWING,
    dafMainServices.RECOVERY,
];
